<template>
  <div id="DmhSlider" class="border-brand-secondary shadow">
    <div class="slider-text">{{ question.slider_text }}</div>
    <div class="slider-container border-brand-secondary">
      <div class="slider-row border-brand-tertiary position-relative">
        <input
          type="range"
          class="native-slider"
          :min="0"
          :max="question.options.length - 1"
          step="1"
          v-model.number="selectedOptionIndex"
          @input="onSlide"
        />

        <button
          v-for="(option, index) in question.options"
          class="slider-button"
          :class="[index === selectedOptionIndex ? 'filled' : 'transparent']"
          :key="index"
          @click="selectOption(option, index)"
        >
          <span class="slider-index">{{ index }}</span>
        </button>

        <div class="line">
          <div class="progress" :style="{ width: getWidth() }"></div>
        </div>
      </div>
    </div>
    <div class="label-container">
      <div class="slider-answer brand-label">Never</div>
      <div class="slider-answer brand-label">Constantly</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Slider",
  props: ["question", "updateAnswer", "index", "defaultOption"],
  data() {
    return {
      selectedOption: this.defaultOption || this.question.options[0],
      selectedOptionIndex: this.defaultOption
        ? this.question.options.findIndex(el => el === this.defaultOption)
        : null
    };
  },
  methods: {
    selectOption(option, index) {
      this.selectedOptionIndex = index;
      this.selectedOption = option;
      this.updateAnswer(this.question, option);
    },

    onSlide() {
      const option = this.question.options[this.selectedOptionIndex];
      this.selectedOption = option;
      this.updateAnswer(this.question, option);
    },

    getWidth() {
      const percent =
        (this.selectedOptionIndex / (this.question.options.length - 1)) * 100;
      return percent + "%";
    }
  }
};
</script>
<style lang="less">
#DmhSlider {
  width: 100%;
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 70px;
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 20px;

  .shadow {
    box-shadow: 0px 4px 24px 0px #00000012;
  }

  .native-slider {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    height: 40px;
    opacity: 0;
    z-index: 10;
    cursor: pointer;
  }

  .slider-text {
    font-size: 1.6rem;
    margin-bottom: 16px;
    align-self: flex-start;
  }

  .slider-index {
    font-size: 1.4rem;
    font-family: var(--font-bold, "DMSans Bold");
    position: relative;
    top: 32px;
  }

  .slider-container {
    width: 100%;
    display: flex;
    flex: 1 1 0px;
    border-radius: 1000px;
    margin-bottom: 24px;
  }

  .slider-row {
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 50px;

    .line {
      height: 16px;
      width: calc(100% - 3px);
      position: absolute;
      top: calc(50% - 8px);
      z-index: 3;
      border-radius: 40px;
      overflow: hidden;
      background-color: rgba(30, 30, 34, 0.05);
    }

    .progress {
      background-color: var(--brand-primary);
      height: 100%;
      border-radius: 40px;
      max-width: 100%;
    }
  }

  .slider-button {
    cursor: pointer;
    width: 36px;
    height: 36px;
    border: 4px solid;
    border-color: var(--brand-primary);
    border-radius: 100px;
    z-index: 5;

    &.filled {
      background-color: var(--brand-primary);
    }

    &.transparent {
      border-color: transparent;
      background-color: transparent;
    }
  }

  .slider-button.bg-brand-primary {
    border: none;
  }

  .slider-answer {
    font-family: var(--font-bold, "DMSans Bold");
    font-size: 1.6rem;
    margin-top: 20px;
    color: #797b89;
  }

  .slider-answer::before {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #dbdbdb;
  }

  .label-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  @media only screen and (max-width: 992px) {
    .slider-row {
      gap: 20px;
    }
    .slider-button {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
